import { render, staticRenderFns } from "./Alarmas_Dia.vue?vue&type=template&id=61432d97&scoped=true&"
import script from "./Alarmas_Dia.vue?vue&type=script&lang=js&"
export * from "./Alarmas_Dia.vue?vue&type=script&lang=js&"
import style0 from "./Alarmas_Dia.vue?vue&type=style&index=0&id=61432d97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61432d97",
  null
  
)

export default component.exports